import React from "react";
import UnorderedList from "src/components/UnorderedList";

interface Props {}

const GoogleSoftwareEngineer: React.FC<Props> = () => {
    return (
        <>
            Yet to be written. I'm working on protecting Google from software
            supply chain attacks.
        </>
    );
};

export default GoogleSoftwareEngineer;
